import { 
    ACCPBOSS_BEGIN,
    ACCPBOSS_ADD,
    ACCPBOSS_FAILURE,
    ACCPBOSS_CLEAR,

    ACCPBOSS_FILTER_BEGIN,
    ACCPBOSS_FILTER_SUCCESS,
    ACCPBOSS_FILTER_FAILURE,
    ACCPBOSS_FILTER_CLEAR,

    ACCPBOSSAVAILABLE_ADD,
    ACCPBOSSAVAILABLE_BEGIN,
    ACCPBOSSAVAILABLE_FAILURE,
    ACCPBOSSAVAILABLE_CLEAR

} from 'app/actions/ACCPBossActions';

const initialState = {
    byId: {},
    allIds: [],
    filterData: [],
    byIdAvailable: {},
    allIdsAvailable: [],
    isLoading: false,
    isLoadingACCPBossAvailable: false,
};

export default function ACCPBossReducer (state = initialState, action) {
	switch (action.type) {
        case ACCPBOSS_BEGIN: 
			return {
				...state,
				isLoading: true
			}
        case ACCPBOSS_ADD:
			//let allIds = [...new Set(state.allIds.concat(action.payload.data.allIds))];
            let allIds = action.payload.data.allIds;
			let byId = {
				...state.byId,
				...action.payload.data.byId
			};
			return {
				...state,
				allIds,
				byId,
				isLoading: false,
            };
        case ACCPBOSS_CLEAR:
            return {
                ...state,
                byId: {},
                allIds: [],
                isLoading: false,
            }
        case ACCPBOSS_FAILURE: 
			return {
				...state,
				isLoading: false
            }
        case ACCPBOSS_FILTER_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case ACCPBOSS_FILTER_SUCCESS:
            let filterData = [...new Set(state.filterData.concat(action.payload.filterData))];
            return {
                ...state,
                filterData,
                isLoading: false,
            };
        case ACCPBOSS_FILTER_CLEAR:
            return {
                ...state,
                filterData: [],
                isLoading: false,
            }
        case ACCPBOSS_FILTER_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case ACCPBOSSAVAILABLE_BEGIN:
            return {
                ...state,
                isLoadingACCPBossAvailable: true
            }
        case ACCPBOSSAVAILABLE_ADD:
            let allIdsAvailable = action.payload.data.Data;
            let byIdAvailable = {
                ...state.byIdAvailable,
            };
            return {
                ...state,
                allIdsAvailable,
                byIdAvailable,
                isLoadingACCPBossAvailable: false,
            };
        case ACCPBOSSAVAILABLE_CLEAR:
            return {
                ...state,
                byIdAvailable: {},
                allIdsAvailable: [],
                isLoadingACCPBossAvailable: false,
            }
        case ACCPBOSSAVAILABLE_FAILURE:
            return {
                ...state,
                isLoadingACCPBossAvailable: false
            }
		default:
			return state;
	}
};

export const getACCPBoss = state => {
	return state.allIds.map( id => state.byId[id] );
}

export const getIsLoadingACCPBoss = state => {
    return state.isLoading;
}

export const getACCPBossFilter = state => {
    return state.filterData
}
export const getIsLoadingACCPBossFilter = state => {
    return state.isLoading;
}

export const getACCPBossAvailable = state => {
    return state.allIdsAvailable;
}

export const getIsLoadingACCPBossAvailable = state => {
    return state.isLoadingACCPBossAvailable;
}
